import React from 'react';

interface FilterProps {
    filters: {
        startDate: string;
        endDate: string;
        statusName: string;
        guestName: string;
        transactionCode: string;
    };
    onFilterChange: (key: string, value: string) => void;
}

export const TransaccionFilter: React.FC<FilterProps> = ({ filters, onFilterChange }) => {
    
    // Estados requeridos: Todas, Pagadas, Pendientes
    const statusOptions = [
        { id: 'TODAS', label: 'Todas' },
        { id: 'AUTHORIZED', label: 'Pagadas' },
        { id: 'PENDING', label: 'Pendientes' },
    ];

    return (
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 px-4 sm:px-7 py-3 border-b border-gray-200 bg-white shrink-0 sm:overflow-x-auto hide-scrollbar">
            
            {/* Buscador */}
            <div className="flex items-center w-full sm:w-[300px] gap-2 px-3 py-1.5 transition-colors border border-gray-300 rounded-lg bg-white focus-within:border-[#4f6df5] focus-within:ring-1 focus-within:ring-[#4f6df5]/20 shrink-0">
                <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24" className="shrink-0">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input 
                    type="text" 
                    placeholder="Buscar por usuario..." 
                    className="w-full text-[13px] bg-transparent border-none outline-none text-gray-900 placeholder:text-gray-400"
                    value={filters.guestName}
                    onChange={(e) => onFilterChange('guestName', e.target.value)}
                />
            </div>
            
            {/* Chips de filtros */}
            <div className="flex items-center gap-2 w-full sm:w-auto overflow-x-auto sm:overflow-visible hide-scrollbar shrink-0 pb-1 sm:pb-0">
                {statusOptions.map(opt => (
                    <button 
                        key={opt.id}
                        onClick={() => onFilterChange('statusName', opt.id)}
                        className={`whitespace-nowrap px-3 py-1.5 text-[11px] font-semibold transition-all border rounded-full shrink-0 ${
                            filters.statusName === opt.id 
                                ? 'bg-[#4f6df5] text-white border-[#4f6df5] shadow-sm' 
                                : 'bg-white text-gray-500 border-gray-200 hover:text-gray-900 hover:bg-gray-50'
                        }`}
                    >
                        {opt.label}
                    </button>
                ))}
            </div>

            {/* Fechas */}
            <div className="flex items-center gap-2 w-full sm:w-auto shrink-0">
                <input 
                    type="date" 
                    value={filters.startDate}
                    onChange={(e) => onFilterChange('startDate', e.target.value)}
                    className="flex-1 sm:flex-none px-3 py-1.5 text-xs bg-white border border-gray-300 rounded-lg text-gray-700 outline-none cursor-pointer shrink-0 focus:border-[#4f6df5]" 
                />
                <span className="text-gray-400 text-xs">-</span>
                <input 
                    type="date" 
                    value={filters.endDate}
                    onChange={(e) => onFilterChange('endDate', e.target.value)}
                    className="flex-1 sm:flex-none px-3 py-1.5 text-xs bg-white border border-gray-300 rounded-lg text-gray-700 outline-none cursor-pointer shrink-0 focus:border-[#4f6df5]" 
                />
            </div>
        </div>
    );
};

export default TransaccionFilter;